<template lang="pug">
  .form-user
    .columns.is-multiline
      .column.is-6-tablet.is-6-desktop
        ui-field(label="Название" v-model="value.name" :error="errors.name" rules="required")
</template>

<script>
export default {
  name: 'form-category',

  props: {
    value: null,
    errors: { type: Object, default: () => ({}) },
  },
};
</script>
